import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Event } from '../types/calendar';

interface CalendarStore {
  events: Event[];
  addEvent: (event: Omit<Event, 'id'>) => void;
  updateEvent: (id: string, event: Partial<Event>) => void;
  deleteEvent: (id: string) => void;
  getEventsByDate: (date: Date) => Event[];
  getEventsByDateRange: (start: Date, end: Date) => Event[];
}

export const useCalendarStore = create<CalendarStore>()(
  persist(
    (set, get) => ({
      events: [],
      
      addEvent: (event) => set((state) => ({
        events: [...state.events, { ...event, id: crypto.randomUUID() }]
      })),
      
      updateEvent: (id, updatedEvent) => set((state) => ({
        events: state.events.map((event) =>
          event.id === id ? { ...event, ...updatedEvent } : event
        )
      })),
      
      deleteEvent: (id) => set((state) => ({
        events: state.events.filter((event) => event.id !== id)
      })),
      
      getEventsByDate: (date) => {
        const events = get().events;
        return events.filter((event) => {
          const eventDate = new Date(event.start);
          return (
            eventDate.getFullYear() === date.getFullYear() &&
            eventDate.getMonth() === date.getMonth() &&
            eventDate.getDate() === date.getDate()
          );
        });
      },
      
      getEventsByDateRange: (start, end) => {
        const events = get().events;
        return events.filter((event) => {
          const eventStart = new Date(event.start);
          return eventStart >= start && eventStart <= end;
        });
      }
    }),
    {
      name: 'calendar-storage'
    }
  )
);